import styled from "styled-components";
import { measures } from "../../theme/measures";

export const VirtualListOuterContainer = styled.div`
    position: relative; 
    width: 100%; 
    height: calc(100vh - ${measures.headerHeight});
    overflow-y: auto;
    contain: strict;
`;


export const VirtualListInnerContainer = styled.div`
    width: 100%;
    position: relative;
`;

export const VirtalListMoving = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
`;
